import React from 'react';
import { MessageBar, MessageBarBody } from '@fluentui/react-message-bar';


export const ErrorMessage = (props) => {
  const {
    error,
  } = props;

  if (error == null) return null;

  return (error && error.length > 0 &&
    <div className="aigc-error">
      <MessageBar key="error" intent="error">
        <MessageBarBody>
          {error}
        </MessageBarBody>
      </MessageBar>
    </div>);
};

